module.exports = __webpack_public_path__ + "static/media/cases_item_4.6ea1916d.png";